module.exports = "<div class=\"quality-components\">\n  <div class=\"current-quality\" data-ref=\"\"></div>\n  <ul class=\"quality-list\">\n  </ul>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/lesson/play/components/aliplayer/components/QualityComponent/index.html
// module id = bEF3
// module chunks = 2